import type { ActionReducerMap } from '@ngrx/store';
import { createFeatureSelector } from '@ngrx/store';

import {
  generalAdviceFormReducer,
  generalAdviceFormSelectorKey,
  type GeneralAdviceFormState,
} from './reducers';

export const fehStandaloneFormsStoreSelectorKey = 'fehStandaloneForms';

export interface FehStandaloneFormsState {
  readonly [generalAdviceFormSelectorKey]: GeneralAdviceFormState;
}

export const reducers: ActionReducerMap<FehStandaloneFormsState> = {
  [generalAdviceFormSelectorKey]: generalAdviceFormReducer,
};

export const selectFehStandaloneFormsState =
  createFeatureSelector<FehStandaloneFormsState>(
    fehStandaloneFormsStoreSelectorKey
  );
